module.exports = __webpack_public_path__ + "img/CARAC3.949b1024.jpg";